import React from 'react';
import './ExtracurricularCart.css';

const ExtracurricularCart = ({ Extracurriculars, onRemoveExtracurricular }) => {
  return (
    <div>
      {Extracurriculars.length === 0 ? (
        <p>Add classes to the cart</p>
      ) : (
        <div>
          {Object.entries(Extracurriculars).map((ExtracurricularName, Extracurricular) => (
            <div key={ExtracurricularName} className="class-cart-item">
              <p style={{ fontSize: '1.1em' }}>{ExtracurricularName[1]}</p>
              {/* Add more details if needed */}
              <div className="remove-button-container">
                <button className="btn btn-danger remove-button" onClick={() => onRemoveExtracurricular(ExtracurricularName[1])}>
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExtracurricularCart;
